import { api } from "@/lib/api";
import { toast } from "sonner";

const path = (id, scope) => (scope === "student" ? `/fees/me/receipt/${id}` : `/fees/receipt/${id}`);

async function errText(e) {
  const d = e.response?.data;
  if (d && typeof d === "object" && typeof d.text === "function") {
    try { return JSON.parse(await d.text()).detail; } catch { return null; }
  }
  return e.response?.data?.detail;
}

export async function viewReceipt(id, scope = "admin") {
  try {
    const { data } = await api.get(path(id, scope), { params: { format: "html" }, responseType: "text" });
    const w = window.open("", "_blank");
    if (!w) { toast.error("Please allow pop-ups to view the receipt"); return; }
    w.document.open(); w.document.write(data); w.document.close();
  } catch (e) { toast.error((await errText(e)) || "Could not open the receipt"); }
}

export async function downloadReceiptPdf(id, scope = "admin", receiptNo = "receipt") {
  try {
    const { data } = await api.get(path(id, scope), { params: { format: "pdf" }, responseType: "blob" });
    const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = `${(receiptNo || "receipt").replace(/[\\/]/g, "-")}.pdf`;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 4000);
  } catch (e) { toast.error((await errText(e)) || "Could not download the PDF"); }
}

export async function emailReceipt(id, scope = "admin") {
  try {
    const p = scope === "student" ? `/fees/me/receipt/${id}/email` : `/fees/receipt/${id}/email`;
    const { data } = await api.post(p);
    toast.success(data.message || "Receipt emailed");
  } catch (e) { toast.error(e.response?.data?.detail || "Could not email the receipt"); }
}

export async function openProof(id, { download = false, i = 0 } = {}) {
  try {
    const { data } = await api.get(`/fees/collections/${id}/proof`, {
      params: { ...(download ? { download: 1 } : {}), ...(i ? { i } : {}) }, responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    if (download) a.download = `payment-proof-${id}-${i + 1}.${(data.type || "").includes("pdf") ? "pdf" : (data.type || "").includes("png") ? "png" : "jpg"}`;
    else { a.target = "_blank"; a.rel = "noreferrer"; }
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 8000);
  } catch (e) { toast.error((await errText(e)) || "Could not open the payment proof"); }
}
